import instance from '../../../api/axios'

export interface TelegramStatus {
  enabled: boolean
  linked: boolean
  username: string | null
}

export const loadTelegramStatus = async (): Promise<TelegramStatus> => {
  const response = await instance.get('/telegram')
  return response.data
}

export const createTelegramLink = async (): Promise<{ url: string }> => {
  const response = await instance.post('/telegram/link')
  return response.data
}

export const disconnectTelegram = async (): Promise<void> => {
  await instance.delete('/telegram')
}
